<div
  class="asset-container"
  [class.active]="isActive()"
  #assetContainer
  (contextmenu)="onContextMenu($event)"
  [class.animate-offset]="animateOffset()"
>
  <div class="asset-container-inner">
    @if (showLoadingIndicator()) {
      <app-loading-indicator color="white" class="asset-loading-indicator" size="small"> </app-loading-indicator>
    }
    @if (asset() | canDisplayAsset) {
      @let assetSrc =
        asset().version_data
          | assetVersionUrl
            : asset()
            : asset().version_data.status
            : displayWidth()
            : displayHeight()
            : asset().watermark_enabled && !!gallery().watermark;
      @if (asset().type === 'image') {
        <div
          class="asset"
          [class.with-png-tile]="(asset().version_data.asset_name | assetSupportsTransparency) && controlsVisible()"
          [style.--offset-x]="offset().x * scale() + 'px'"
          [style.--offset-y]="offset().y * scale() + 'px'"
          [style.width]="crop().width + 'px'"
          [style.height]="crop().height + 'px'"
        >
          <img
            id="{{ asset().id }}"
            [src]="assetSrc"
            draggable="false"
            [width]="crop().width"
            [height]="crop().height"
            (load)="load()"
            alt=""
          />
        </div>
      } @else if (asset().type === 'document') {
        <div
          class="asset"
          [style.--offset-x]="offset().x * scale() + 'px'"
          [style.--offset-y]="'0px'"
          [style.width]="crop().width + 'px'"
          [style.height]="
                asset().version_data.data['images'].length > 1 ? '100%' : `min(${crop().height}px, 100%)`
              "
        >
          <app-pdf-viewer
            [src]="pdfBaseSrc()"
            [disabled]="!this.isActive()"
            [activePage]="activePage()"
            (activePageChange)="activePageChange.emit($event)"
            [pages]="asset().version_data.data?.['images']"
            [changePageOnClick]="!!commentPlacementMode()"
            [verticalDragDelta]="verticalDragDelta()"
            (pageLoaded)="imageLoaded.set(true)"
            (offsetChange)="onOffsetChange.emit($event)"
          ></app-pdf-viewer>
        </div>
      } @else if (asset().type === 'video') {
        <app-video-viewer
          #videoViewer
          [commentService]="commentService"
          [class.disable-pointer-events]="commentPlacementMode()"
          [isFocused]="videoFocused()"
          (click)="videoFocusedChange.emit(true)"
          appClickOutside
          (onClickOutside)="isActive() && videoFocusedChange.emit(false)"
          class="asset"
          [videoData]="$any(asset().version_data.data)"
          [assetVersion]="asset().version_data"
          [asset]="asset()"
          [galleryPermissions]="galleryPermissions()"
          [isTeamMember]="isTeamMember()"
          [gallery]="gallery()"
          [uuid]="asset().version_data.uuid"
          [scale]="scale()"
          [poster]="assetSrc"
          [active]="(!isDesktop() || autoplayOnLoad()) && isActive()"
          [activateOnClick]="true"
          [reportTimeChange]="isActive()"
          [targetWidth]="assetContainer.offsetWidth"
          [showUi]="controlsVisible() && !annotationMode() && !commentPlacementMode()"
          [autoplay]="autoplayOnLoad() && isActive()"
          [blockVideoClick]="blockVideoClick()"
          [handleUi]="true"
          [handleKeyboardShortcuts]="isActive() && !annotationMode()"
          [style.--offset-x]="offset().x + 'px'"
          [style.--offset-y]="offset().y + 'px'"
          [style.width]="crop().width + 'px'"
          [style.height]="crop().height + 'px'"
          [selectedThreadId]="selectedThreadId()"
          [showResolved]="showResolved()"
          (onTimeChange)="onTimeChange.emit($event)"
          (selectThread)="selectThreadFromFace.emit($event)"
        ></app-video-viewer>
      } @else if (asset().type === 'audio') {
        <app-audio-viewer
          class="asset"
          [asset]="asset()"
          [assetVersion]="asset().version_data"
          [gallery]="gallery()"
          [active]="isActive()"
          [handleKeyboardShortcuts]="isActive()"
          [reportTimeChange]="isActive()"
          [showControls]="true"
          [autoplay]="autoplayOnLoad() && isActive()"
          [videoData]="$any(asset().version_data.data)"
          [style.--offset-x]="'0%'"
          [style.--offset-y]="'0%'"
          [style.width]="'100%'"
          [style.height]="'calc(100% - 120px)'"
          (onTimeChange)="onTimeChange.emit($event)"
        ></app-audio-viewer>
      }
    } @else {
      <app-non-preview-file
        [asset]="asset()"
        [gallery]="gallery()"
        [showSizeAndDownload]="true"
        [showFilename]="true"
        [darkBackground]="true"
        [showBorder]="false"
        [style.--offset-x]="offset().x + 'px'"
        [style.--offset-y]="offset().y + 'px'"
        [style.width]="'100%'"
        [style.height]="'100%'"
        class="asset"
        id="{{ asset().id }}"
      ></app-non-preview-file>
    }
  </div>
</div>

@if (copyrightInfoPos()) {
  <div class="custom-context-menu-bg" (click)="copyrightInfoPos.set(undefined)"></div>
  <div class="custom-context-menu" [style.left.px]="copyrightInfoPos().x" [style.top.px]="copyrightInfoPos().y">
    © {{ copyrightMessage() }}
  </div>
}
